import { useEffect, useState, useMemo } from 'react';
import {
    Dialog, DialogContent, DialogTitle, IconButton, Card, TableContainer, Tooltip,
    Table,
    TableBody,
    Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider from 'src/components/hook-form';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { useParams } from 'react-router';
import Scrollbar from 'src/components/scrollbar';
import { isEqual } from 'lodash';
import {
    emptyRows,
    getComparator,
    TableEmptyRows,
    TableHeadCustom,
    TableNoData,
    TablePaginationCustom,
    TableSelectedAction,
    useTable,
} from 'src/components/table';
import { useBoolean } from 'src/hooks/use-boolean';
import UserTableRow from './work-order-follow-up-history-table-row';
import { formatCurrency } from '../../risk-register/feching';
const WorkOrderFollowUpHistory = ({ open, onClose, reload, currentItem, closeform, WONumber, WOId, total_balance }) => {

    const theme = useTheme();
    const table = useTable();

    const remove = useBoolean()

    const TABLE_HEAD = [
        { id: 'No.#', label: 'Serial Number', minWidth: 150 },
        { id: 'invoice_number', label: 'Invoice Number', minWidth: 150 },
        { id: 'amount received', label: 'Amount Paid', minWidth: 150 },
        { id: 'Project Name', label: 'Date of Receipt', minWidth: 150 },
        { id: 'Equipments Availability', label: 'Payment Method', minWidth: 150 },
        { id: 'Equipments Availability', label: 'Cheque/Account Number', minWidth: 200 },
        { id: 'Equipments Availability', label: 'Bank Name', minWidth: 150 },
        { id: 'Equipments Availability', label: 'DescrCheque/Card Expiry Date Option', minWidth: 300 },
        { id: 'Equipments Availability', label: 'Remarks / Notes', minWidth: 150 },
        { id: 'Equipments Availability', label: 'Attachment', minWidth: 150 },
        { id: 'Equipments Availability', label: 'Remaining Balance', minWidth: 170 },
    ];

    const [loading, setLoading] = useState(false);

    const [tableData, setTableData] = useState([]);
    const [actionVisible, setActionVisible] = useState(true);
    const [totalBalance, setTotalBalance] = useState(0);

    const NewUserSchema = Yup.object().shape({

    });

    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
    });

    const [filters, setFilters] = useState({
        name: '',
        role: [],
        status: 'all',
    });

    const dataFiltered = applyFilter({
        inputData: tableData.length > 0 ? tableData : [],
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });

    const denseHeight = table.dense ? 52 : 72;
    const canReset = !isEqual({ name: '', role: [], status: 'all' }, filters);
    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

    useEffect(() => {
        getInvoiceHistory();
    }, []);


    const getInvoiceHistory = async () => {
        setLoading(true)
        const data = await getRequest(`${endpoints.accounting.account_payable.work_order_invoice.get_list}${WOId}/wo-invoices`);
        setLoading(false)
        if (data) {
            setTableData(data.invoices)
            setTotalBalance(data.total_balance_to_paid)
        }
    }

    const closeAndReset = () => {
        onClose();
    }

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    closeAndReset();
                }
            }}
            fullWidth
            maxWidth="md"
            sx={{
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            }}
            transitionDuration={{
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            }}
        >
            <FormProvider methods={methods}>

                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'center', boxSizing: 'content-box' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%'
                        }}
                    >
                        <span
                            className='cardColor'
                            style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}>
                            &nbsp;&nbsp;  Work Order Follow Up History  &nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                    </Box>
                    <IconButton onClick={closeAndReset}>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    sx={{
                        borderRadius: '1px',
                    }}
                >
                    <Card
                        className='cardColor'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            padding: '10px',
                            boxShadow: '0px 0px 30px 0px #64748B1A'
                        }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Total Balance:</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{formatCurrency(total_balance)}</Typography>
                    </Card>
                    <Card
                        sx={{
                            boxShadow: '0px 0px 30px 0px #64748B1A',
                        }}
                    >
                        <TableContainer sx={{ position: 'relative', overflow: 'auto' }}>
                            {actionVisible && (
                                <div style={{ marginBottom: table.selected.length > 0 ? '3rem' : '0' }}>
                                    <TableSelectedAction
                                        dense={table.dense}
                                        numSelected={table.selected.length}
                                        rowCount={tableData.length}
                                        onSelectAllRows={(checked) =>
                                            table.onSelectAllRows(
                                                setActionVisible(checked),
                                                checked,
                                                tableData.map((row) => row.id)
                                            )
                                        }
                                        action={
                                            <Tooltip title="Delete">
                                                <IconButton color="primary" onClick={remove.onTrue}>
                                                    <Iconify icon="solar:trash-bin-trash-bold" />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    />
                                </div>
                            )}
                            <Scrollbar>
                                <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
                                    <Scrollbar>
                                        <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 960 }}>
                                            <TableHeadCustom
                                                sx={{
                                                    whiteSpace: 'nowrap'
                                                }}
                                                order={table.order}
                                                orderBy={table.orderBy}
                                                headLabel={TABLE_HEAD}
                                                rowCount={tableData.length}
                                                numSelected={table.selected.length}
                                                onSort={table.onSort}
                                                onSelectAllRows={(checked) =>
                                                    table.onSelectAllRows(
                                                        checked,
                                                        tableData.map((row) => row.id)
                                                    )
                                                }
                                            />
                                            <TableBody>
                                                {dataFiltered
                                                    .slice(
                                                        table.page * table.rowsPerPage,
                                                        table.page * table.rowsPerPage + table.rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <UserTableRow
                                                            key={row.id}
                                                            row={row}
                                                            selected={table.selected.includes(row.id)}
                                                            onSelectRow={() => table.onSelectRow(row.id)}
                                                            WONumber={WONumber}
                                                            serialNumber={table.page * table.rowsPerPage + index + 1}
                                                        />
                                                    ))}
                                                <TableEmptyRows
                                                    height={denseHeight}
                                                    emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
                                                />

                                                <TableNoData notFound={notFound} />
                                            </TableBody>
                                        </Table>
                                    </Scrollbar>
                                </TableContainer>
                            </Scrollbar>
                        </TableContainer>
                        <TablePaginationCustom
                            count={dataFiltered.length}
                            page={table.page}
                            rowsPerPage={table.rowsPerPage}
                            onPageChange={table.onChangePage}
                            onRowsPerPageChange={table.onChangeRowsPerPage}
                            dense={table.dense}
                            onChangeDense={table.onChangeDense}
                        />
                    </Card>
                </DialogContent>
            </FormProvider>
        </Dialog>
    );
};

function applyFilter({ inputData, comparator, filters }) {
    const { name, status, role } = filters;
    const stabilizedThis = inputData.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    inputData = stabilizedThis.map((el) => el[0]);
    if (name) {
        inputData = inputData.filter(
            (user) => user.name.toLowerCase().indexOf(name.toLowerCase()) !== -1
        );
    }
    if (status !== 'all') {
        inputData = inputData.filter((user) => user.status === status);
    }
    if (role.length) {
        inputData = inputData.filter((user) => role.includes(user.role));
    }
    return inputData;
}
export default WorkOrderFollowUpHistory;